module.exports = __webpack_public_path__ + "static/media/nn-Hurtigbenevning-instruction.e65610af.mp3";